// extracted by mini-css-extract-plugin
module.exports = {"container":"SwipeTabLayout_container__BJ_oG","tabContent":"SwipeTabLayout_tabContent__1U3e8","swiper":"SwipeTabLayout_swiper__3igA5","slideItem":"SwipeTabLayout_slideItem__3tF48"};